import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=63cfce20&lang=pug"
import script from "./TextField.vue?vue&type=script&lang=js"
export * from "./TextField.vue?vue&type=script&lang=js"
import style0 from "./TextField.vue?vue&type=style&index=0&id=63cfce20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports